import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink-deep text-white" data-id="element-105" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-106" data-mp="3gfsp4jdu96q5">
        <h3 className="font-display text-2xl font-extrabold tracking-tight text-white" data-id="element-107" data-mp="3gh3rcermy6f5">
          52 Weeks of Volleyball <span className="text-amber" data-id="element-108" data-mp="36pfutzg81z6t">Practice Plans</span>
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-109" data-mp="36ppnjusnikg7">
          A full year of done-for-you practice plans &amp; drills — walk into every practice ready.
        </p>

        <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-1 text-[13px] text-white/70" data-id="element-110" data-mp="387clehl0xbk">
          <a href="mailto:help@iclcollective.com" className="inline-flex min-h-[44px] items-center px-1 hover:text-white hover:underline" data-id="element-111" data-mp="3ldu2qoshwdu8">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-ink-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-112" data-mp="29xm24swmjcl7">
          52 Weeks of Volleyball Practice Plans is a practice-planning resource for
          volleyball coaches. It is not affiliated with or endorsed by USA
          Volleyball, the FIVB, the AVCA or any other governing body. It does not
          replace coach certification, safeguarding or background-check
          requirements, first-aid training, or your club&apos;s, school&apos;s and
          league&apos;s standards on safety and equipment. Results depend on the
          coach and the team; no specific outcome is guaranteed. © 52 Weeks of
          Volleyball Practice Plans 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}